<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <b-input
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :icon="icon"
      :step="step"
      :rows="rows"
      :name="name"
      :disabled="disabled"
      :password-reveal="passwordReveal"
      :class="{'is-danger': hasError()}"
      @input="inputListener"
    />
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator () {
        return true;
      }
    },
    rows: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean
    },
    icon: {
      default: undefined,
      type: String
    },
    type: {
      default: "text",
      type: String
    },
    step: {
      default: "1",
      type: String
    },
    passwordReveal: {
      default: false,
      type: Boolean
    }
  }
};
</script>
